import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class PricelistDownloadService {

  constructor(
    private http: HttpService,
  ) { }

  getList(data?: any) {
    return this.http.post(Path.PRICELIST_DOWNLOAD.GET_LIST, data);
  }
}
